// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__U8mwu","image":"Header_image__2FR_p","name":"Header_name__2ydzP","info":"Header_info__160u4","infoRow":"Header_infoRow__e_Nqh"};